/* Quit Mood 独立站 V1 — 交互 */
(function () {
  'use strict';

  /* ---------- 顶部通告条:领取状态 + 关闭 ---------- */
  function readCookie(name) {
    var hit = document.cookie.split(';').filter(function (c) {
      return c.trim().indexOf(name + '=') === 0;
    })[0];
    return hit ? decodeURIComponent(hit.trim().slice(name.length + 1)) : '';
  }

  function initAnnounceState() {
    document.querySelectorAll('[data-v1-announce]').forEach(function (bar) {
      var code = (bar.dataset.v1AnnounceCode || '').trim();
      var offer = bar.querySelector('[data-v1-announce-offer]');
      var applied = bar.querySelector('[data-v1-announce-applied]');
      if (!code || !offer || !applied) return;

      // 以 Shopify 自己写的 discount_code cookie 为准,而不是本地标记,
      // 这样 cookie 失效时会自动退回未领取态,不会给出虚假承诺
      function sync() {
        var on = readCookie('discount_code').toUpperCase() === code.toUpperCase();
        offer.hidden = on;
        applied.hidden = !on;
      }
      sync();

      // 点击后 Shopify 要跳转一次才会写 cookie,回来时 sync() 自然会命中;
      // 但若浏览器从 bfcache 恢复页面,不会重跑脚本,这里补一次
      window.addEventListener('pageshow', sync);
    });
  }

  function initAnnounce() {
    initAnnounceState();
    document.querySelectorAll('[data-v1-announce-dismissible]').forEach(function (bar) {
      var key = 'v1-announce-closed';
      var close = bar.querySelector('[data-v1-announce-close]');
      try {
        if (localStorage.getItem(key) === '1') {
          bar.hidden = true;
          return;
        }
      } catch (e) {
        /* 隐私模式下 localStorage 会抛异常,忽略即可,大不了每次都显示 */
      }
      if (!close) return;
      close.addEventListener('click', function () {
        bar.hidden = true;
        try {
          localStorage.setItem(key, '1');
        } catch (e) {}
      });
    });
  }

  /* ---------- 页头:移动端菜单 ---------- */
  function initHeader() {
    document.querySelectorAll('[data-v1-header]').forEach(function (header) {
      var burger = header.querySelector('[data-v1-burger]');
      if (!burger) return;
      burger.addEventListener('click', function () {
        var open = header.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- 评价卡:More 展开 ---------- */
  function initReviews() {
    document.querySelectorAll('[data-v1-review-more]').forEach(function (btn) {
      var card = btn.closest('.v1-review');
      if (!card) return;
      var text = card.querySelector('.v1-review__text');
      // 未溢出的短评价不需要 More
      if (text && text.scrollHeight <= text.clientHeight + 1) {
        btn.hidden = true;
        return;
      }
      btn.addEventListener('click', function () {
        var open = card.classList.toggle('is-open');
        btn.textContent = open ? btn.dataset.less || 'Less' : btn.dataset.more || 'More';
      });
    });
  }

  /* ---------- 商品图廊 ---------- */
  function initGallery() {
    document.querySelectorAll('[data-v1-gallery]').forEach(function (root) {
      var images = Array.prototype.slice.call(root.querySelectorAll('[data-v1-gallery-image]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-v1-gallery-thumb]'));
      if (images.length < 1) return;
      var index = 0;

      function show(next) {
        index = (next + images.length) % images.length;
        images.forEach(function (img, i) {
          img.classList.toggle('is-active', i === index);
        });
        thumbs.forEach(function (t, i) {
          t.classList.toggle('is-active', i === index);
          t.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          show(i);
        });
      });
      var prev = root.querySelector('[data-v1-gallery-prev]');
      var next = root.querySelector('[data-v1-gallery-next]');
      if (prev) {
        prev.addEventListener('click', function () {
          show(index - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          show(index + 1);
        });
      }
      show(0);
    });
  }

  /* ---------- 购买模块:订阅切换 + 方案选择 ---------- */
  function initBuyBox() {
    document.querySelectorAll('[data-v1-buybox]').forEach(function (root) {
      var plans = Array.prototype.slice.call(root.querySelectorAll('[data-v1-plan]'));
      var variantInput = root.querySelector('[data-v1-variant-input]');
      var quantityInput = root.querySelector('[data-v1-quantity-input]');
      var sellingPlanInput = root.querySelector('[data-v1-selling-plan-input]');
      var submit = root.querySelector('[data-v1-submit]');
      var toggles = Array.prototype.slice.call(root.querySelectorAll('[data-v1-mode]'));
      var perks = root.querySelector('[data-v1-perks]');
      var mode = root.dataset.defaultMode || 'onetime';

      function priceFor(plan) {
        return mode === 'subscription' && plan.dataset.subPrice
          ? plan.dataset.subPrice
          : plan.dataset.price;
      }
      function unitFor(plan) {
        return mode === 'subscription' && plan.dataset.subUnit
          ? plan.dataset.subUnit
          : plan.dataset.unit;
      }

      function selectPlan(plan) {
        plans.forEach(function (p) {
          var on = p === plan;
          p.classList.toggle('is-selected', on);
          var radio = p.querySelector('input[type="radio"]');
          if (radio) radio.checked = on;
        });
        if (variantInput) variantInput.value = plan.dataset.variantId || '';
        if (quantityInput) quantityInput.value = plan.dataset.quantity || '1';
        if (sellingPlanInput) {
          var planId = mode === 'subscription' ? plan.dataset.sellingPlanId || '' : '';
          sellingPlanInput.value = planId;
          // 空的 selling_plan 会被 /cart/add 当成无效参数,没订阅时直接不提交这个字段
          sellingPlanInput.disabled = planId === '';
        }
        if (submit) {
          var unavailable = plan.dataset.available === 'false';
          submit.disabled = unavailable;
          submit.textContent = unavailable
            ? submit.dataset.soldOut || 'Sold out'
            : submit.dataset.label || 'Add to Cart';
        }
      }

      function refreshPrices() {
        plans.forEach(function (plan) {
          var priceEl = plan.querySelector('[data-v1-plan-price]');
          var unitEl = plan.querySelector('[data-v1-plan-unit]');
          if (priceEl) priceEl.textContent = priceFor(plan);
          if (unitEl) unitEl.textContent = unitFor(plan);

          // 角标要跟着模式走:订阅价更低,相对划线价的折扣率和单次购买不同
          var badgeEl = plan.querySelector('[data-v1-plan-badge]');
          if (badgeEl) {
            var sub = mode === 'subscription';
            var text = sub ? plan.dataset.subBadge : plan.dataset.badge;
            var gold = (sub ? plan.dataset.subBadgeGold : plan.dataset.badgeGold) === 'true';
            badgeEl.textContent = text || '';
            badgeEl.hidden = !text;
            badgeEl.classList.toggle('v1-plan__badge--gold', gold);
          }
        });
      }

      function setMode(next) {
        mode = next;
        toggles.forEach(function (t) {
          t.classList.toggle('is-active', t.dataset.v1Mode === mode);
          t.setAttribute('aria-pressed', t.dataset.v1Mode === mode ? 'true' : 'false');
        });
        // 没有订阅计划时不渲染切换条,此时权益区常驻显示;只有能切换时才跟随模式隐藏
        if (perks && toggles.length > 0) perks.hidden = mode !== 'subscription';
        refreshPrices();
        var current = plans.filter(function (p) {
          return p.classList.contains('is-selected');
        })[0];
        if (current) selectPlan(current);
      }

      plans.forEach(function (plan) {
        plan.addEventListener('click', function () {
          selectPlan(plan);
        });
        plan.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectPlan(plan);
          }
        });
      });

      toggles.forEach(function (t) {
        t.addEventListener('click', function () {
          setMode(t.dataset.v1Mode);
        });
      });

      var preselected =
        plans.filter(function (p) {
          return p.dataset.default === 'true';
        })[0] || plans[0];
      if (preselected) selectPlan(preselected);
      setMode(mode);
    });
  }

  /* ---------- 折叠面板(购买说明 / FAQ) ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-v1-accordion]').forEach(function (root) {
      var single = root.dataset.v1Accordion === 'single';
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-v1-acc-btn]'));
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          var open = btn.getAttribute('aria-expanded') === 'true';
          if (single && !open) {
            buttons.forEach(function (other) {
              if (other === btn) return;
              other.setAttribute('aria-expanded', 'false');
              var op = document.getElementById(other.getAttribute('aria-controls'));
              if (op) op.classList.remove('is-open');
            });
          }
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (panel) panel.classList.toggle('is-open', !open);
        });
      });
    });
  }

  /* ---------- 视频卡:点击播放 ---------- */
  function initVideoCards() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-v1-video-card]'));
    cards.forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;
      card.addEventListener('click', function () {
        if (video.paused) {
          cards.forEach(function (other) {
            if (other === card) return;
            var ov = other.querySelector('video');
            if (ov && !ov.paused) {
              ov.pause();
              other.classList.remove('is-playing');
            }
          });
          video.play();
          card.classList.add('is-playing');
        } else {
          video.pause();
          card.classList.remove('is-playing');
        }
      });
      video.addEventListener('ended', function () {
        card.classList.remove('is-playing');
      });
    });
  }

  /* ---------- 通用优惠弹窗 + 左下角固定角标 ---------- */
  function initPromoPopup() {
    var root = document.querySelector('[data-v1-promo]');
    if (!root || root.dataset.v1PromoReady === '1') return;
    root.dataset.v1PromoReady = '1';

    var modal = root.querySelector('[data-v1-promo-modal]');
    var tab = root.querySelector('[data-v1-promo-tab]');
    if (!modal || !tab) return;

    var SEEN = 'v1-promo-seen'; // 本会话已经自动弹过
    var TAB_OFF = 'v1-promo-tab-off'; // 角标也被关掉了
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    // 隐私模式下 sessionStorage 会抛异常,读不到就当没弹过,大不了多弹一次
    function flag(key) {
      try {
        return sessionStorage.getItem(key) === '1';
      } catch (e) {
        return false;
      }
    }
    function setFlag(key) {
      try {
        sessionStorage.setItem(key, '1');
      } catch (e) {}
    }

    function open() {
      modal.hidden = false;
      tab.hidden = true;
      // 编辑器里不锁滚动,否则商家改别的区块时页面动不了
      if (!designMode) document.documentElement.classList.add('v1-promo-open');
      // 焦点收进对话框本身,而不是 CTA:按钮上会留一圈可见焦点环,设计稿里没有
      var card = modal.querySelector('[role="dialog"]');
      if (card) card.focus({ preventScroll: true });
    }

    function close() {
      modal.hidden = true;
      document.documentElement.classList.remove('v1-promo-open');
      setFlag(SEEN);
      // 与弹窗联动:关掉弹窗后角标顶上,除非访客已经把角标也关了
      if (!flag(TAB_OFF)) tab.hidden = false;
    }

    modal.querySelectorAll('[data-v1-promo-dismiss]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    // 走 SHOP NOW 也算看过了,不要下一页又弹一次
    var go = modal.querySelector('[data-v1-promo-go]');
    if (go) {
      go.addEventListener('click', function () {
        setFlag(SEEN);
        setFlag(TAB_OFF);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    var reopen = tab.querySelector('[data-v1-promo-reopen]');
    if (reopen) reopen.addEventListener('click', open);
    var tabClose = tab.querySelector('[data-v1-promo-tab-close]');
    if (tabClose) {
      tabClose.addEventListener('click', function () {
        tab.hidden = true;
        setFlag(TAB_OFF);
      });
    }

    // 主题编辑器里直接展开,免得商家看不到自己在编辑什么
    if (designMode) {
      open();
      return;
    }
    if (flag(SEEN)) {
      if (!flag(TAB_OFF)) tab.hidden = false;
      return;
    }
    var delay = parseInt(root.dataset.v1PromoDelay, 10);
    window.setTimeout(open, isNaN(delay) ? 500 : delay);
  }

  function init() {
    initAnnounce();
    initHeader();
    initReviews();
    initGallery();
    initBuyBox();
    initAccordions();
    initVideoCards();
    initPromoPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // 主题编辑器中重新加载 section 后重新绑定
  document.addEventListener('shopify:section:load', init);
})();
